import { render, staticRenderFns } from "./HeatReport.vue?vue&type=template&id=4982a0e1&scoped=true&"
import script from "./HeatReport.vue?vue&type=script&lang=js&"
export * from "./HeatReport.vue?vue&type=script&lang=js&"
import style0 from "./HeatReport.vue?vue&type=style&index=0&id=4982a0e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4982a0e1",
  null
  
)

export default component.exports